import { render } from "./Steps.vue?vue&type=template&id=604e42cb&scoped=true"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"

import "./Steps.vue?vue&type=style&index=0&id=604e42cb&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/doineedavpn.com/doineedavpn.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604e42cb"]])

export default __exports__